import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { InfoTooltip } from '@bluebeam/react-skyline-info-tooltip';
import { Label } from '@bluebeam/react-skyline-label';
import { useRadioGroup } from 'react-aria';
import { useRadioGroupState } from 'react-stately';
import { RadioProvider } from './RadioContext';
import RadioOption from './RadioOption';
const RadioGroup = ({ ariaLabel, children, defaultValue, description, isRequired = false, label, onChange, row = false, tooltip, value, ...rest }) => {
    const ariaProps = {
        'aria-label': ariaLabel,
        defaultValue,
        description,
        isRequired,
        label,
        onChange,
        value,
    };
    const state = useRadioGroupState(ariaProps);
    const { descriptionProps, labelProps, radioGroupProps } = useRadioGroup(ariaProps, state);
    const dataAttributes = useDataAttributes(rest);
    return (_jsxs(Label, { ...labelProps, ...dataAttributes, children: [_jsxs("span", { children: [isRequired ? `${label}*` : label, tooltip && _jsx(InfoTooltip, { tooltip: tooltip })] }), _jsxs("div", { className: "flex flex-col gap-1", onClick: (e) => e.stopPropagation(), ...radioGroupProps, children: [_jsx(RadioProvider, { value: state, children: _jsx("div", { className: buildClassName('align-center flex flex-wrap gap-x-6 gap-y-4', row ? 'flex-row' : 'flex-col'), children: children }) }), description && (_jsx("div", { ...descriptionProps, className: "text-darker-gray text-sm", children: description }))] })] }));
};
RadioGroup.Option = RadioOption;
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map